let productOptions = document.querySelectorAll('.js-product-options');

productOptions = Array.from(productOptions);

productOptions.forEach((option) => {
    const handle = option.getAttribute('data-product-form');

    fetch('/products/' + handle + '.js')
    .then(function(response) {
      response.json().then(data => {
        let product = data;

        function updateSelection() {

            console.log('updating selection');

            let sel = []

            var productOptions = option.querySelectorAll('.js-product-option')

            productOptions.forEach(function (option) {
              let selectedIndex = option.querySelector('select').selectedIndex;
              let value = option.querySelector('select')[selectedIndex];

              sel.push(value);

            });

            let id = sel[0].dataset.id;
            let selection = product.variants.filter(variant => variant.id == id)[0];

            // if (selection) {
            //   let available = selection.available;
            // }

            // if (!available) {
            //     console.log('unavailable');
            //     document.querySelector('.product__content .js-add-to-cart span').textContent = 'Sold Out';
            //     document.querySelector('.product__content .js-add-to-cart').classList.add('cta--disabled');
            //     document.querySelector('.product__content .js-add-to-cart').disabled = true;
            //     document.querySelector('.product__content .product__sold-out-contact').classList.add('active');
            // } else {
            //     document.querySelector('.product__content .js-add-to-cart span').textContent = 'Add to Cart';
            //     document.querySelector('.product__content .js-add-to-cart').classList.remove('cta--disabled');
            //     document.querySelector('.product__content .js-add-to-cart').disabled = false;
            //     document.querySelector('.product__content .product__sold-out-contact').classList.remove('active');
            // }

            // let imageMap = Array.from(document.querySelectorAll('.option__image .image__wrapper')).filter(image => image.getAttribute('data-variant-title') === selection.title)[0];

            let currentActive = document.querySelector('.option__image .image__wrapper.active');

            if (currentActive) {
              currentActive.classList.remove('active');
            }

            // imageMap.classList.add('active');

            // update price
            // let price = selection.price;
            // document.querySelector('.js-price').textContent = Shopify.formatMoney(price).replace(".00", "");

            // update qty-input
            // document.querySelector('.js-qty').value = 1;

            // update inventory-qty
            let selector = option.querySelector('.js-product-option select');
            // let inventoryQty = selector.selectedOptions[0].getAttribute('data-inventory-qty');

            // if (inventoryQty && inventoryQty > 0 && inventoryQty < 5) {
            //   document.querySelector('.product-main__inventory-quantity').textContent = 'Only ' + inventoryQty + ' left!';
            // } else if (inventoryQty && inventoryQty == 0) {
            //   document.querySelector('.product-main__inventory-quantity').textContent = '';
            // } else {
            //   document.querySelector('.product-main__inventory-quantity').textContent = '';
            // }

            // update max
            // if (inventoryQty && inventoryQty > 0) {
            //   document.querySelector('.js-qty').max = inventoryQty;
            // } else if (inventoryQty == 0) {
            //   document.querySelector('.js-qty').max = 1;
            // } else {
            //   document.querySelector('.js-qty').removeAttribute('max');
            // }

            // update cart button
            // let addButton = document.querySelector('.js-add-to-cart');
            // addButton.setAttribute('data-id', selection.id);

            // update url
            if (selection) {
              var newUrl = window.location.href.split('?')[0] + '?variant=' + selection.id;
              // history.pushState({}, null, newUrl);
              window.location = newUrl
            }
        }

        // updateSelection();

        let productOption =  option.querySelector('.js-product-option');

        productOption.addEventListener('change', (event) => {
          console.log('changed product option');
          updateSelection();
        });
      });

    })
    .catch(function(error) {
      console.log(error);
    });
  });
